import React from 'react'
import cx from 'classnames'
import classes from 'styles/HeaderBar.module.scss'
import { SignOutButton } from '@/components/signin/SignOutButton'
import Image from 'next/image'
import { Tooltip, Button, Popup } from '@fluentui/react-northstar'
import { useSession } from 'next-auth/react'
import Link from 'next/link'
import { SUPPORT_MAIL } from '@/constantsClient'
import { SafeAvatar } from '@/components/SafeAvatar'
import { useTeamsMobile } from '@/hooks/useTeamsMobile'

interface IHeaderBarProps {
  showLogOutButton?: boolean
  className?: string
}

export const HeaderBar: React.FC<IHeaderBarProps> = ({
  showLogOutButton = true,
  className = '',
}) => {
  const session = useSession()
  const email = session.data?.user?.email
  const image = session.data?.user?.image
  const name = session.data?.user?.name
  const isMobile = useTeamsMobile()

  const handleFeedback = () => {
    window.location.href = '/contact-us'
  }

  const menuItems = (
    <div className={classes.menuContent}>
      <Link href="/app" legacyBehavior passHref>
        <a style={{ width: '100%' }}>
          <Button text fluid content="Dashboard" className={classes.menuItem} />
        </a>
      </Link>
      {!isMobile && (
        <>
          <Link href="/pricing" legacyBehavior passHref>
            <a style={{ width: '100%' }}>
              <Button text fluid content="Pricing" className={classes.menuItem} />
            </a>
          </Link>
          <Link href="/account/subscription" legacyBehavior passHref>
            <a style={{ width: '100%' }}>
              <Button text fluid content="Subscription" className={classes.menuItem} />
            </a>
          </Link>
        </>
      )}
      <Link href="/account/preferences" legacyBehavior passHref>
        <a style={{ width: '100%' }}>
          <Button text fluid content="Preferences" className={classes.menuItem} />
        </a>
      </Link>
      {!isMobile && (
        <Link href="/account/manage-team" legacyBehavior passHref>
          <a style={{ width: '100%' }}>
            <Button text fluid content="Team Management" className={classes.menuItem} />
          </a>
        </Link>
      )}
      <Link href="/templates" legacyBehavior passHref>
        <a style={{ width: '100%' }}>
          <Button text fluid content="Templates" className={classes.menuItem} />
        </a>
      </Link>
      <Button
        text
        fluid
        content="Contact Us"
        onClick={handleFeedback}
        className={classes.menuItem}
      />
      <div className={classes.separator}></div>
      <SignOutButton fluid className={classes.signOutItem} />
    </div>
  )

  return (
    <header className={cx(classes.header, className)}>
      <Link href="/app" legacyBehavior>
        <a className="flex items-center cursor-pointer">
          <Image src="/logo.png" alt="App logo" width={36} height={36} />
          <h1 className={classes.appName}>Delayed Send</h1>
        </a>
      </Link>

      {/* Show menu if user is logged in, even if image is missing */}
      {showLogOutButton && session.status === 'authenticated' && (
        <Popup
          content={
            <>
              <div className={classes.userInfoHeader}>
                {name || 'User'} ({email || 'No email'})
              </div>
              {menuItems}
            </>
          }
          position="below"
          trigger={
            <div className={classes.avatarContainer}>
              <SafeAvatar
                image={image ? { src: image } : undefined}
                className={classes.avatarTrigger}
                title="Menu"
              />
            </div>
          }
        />
      )}
    </header>
  )
}
